module.exports = __webpack_public_path__ + "img/Andaluza-17-min.52796483.jpg";